// extracted by mini-css-extract-plugin
export default {"linkContainer":"c182a0e3","container":"b995a446"};